import React from 'react';
import OrderList from '../components/OrderList';

export default function UrgentOrders() {
  return (
    <OrderList
      status="pending"
      defaultPriority="urgent"
      title="紧急订单"
      desc="调度待跟进工单中优先级为「紧急重要」的订单，优先级最高，需第一时间响应处理；处理完成或结束后自动移出"
    />
  );
}
